import { render, staticRenderFns } from "./screenshot-zoom.vue?vue&type=template&id=0831985a"
import script from "./screenshot-zoom.vue?vue&type=script&lang=js"
export * from "./screenshot-zoom.vue?vue&type=script&lang=js"
import style0 from "./screenshot-zoom.vue?vue&type=style&index=0&id=0831985a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports